module.exports = __webpack_public_path__ + "static/main-app-image-b9901585f6fafed133f528d1458f5c8f.png";